import React, { useState } from 'react';
import { auth, db } from '../firebase'; // Firebase config
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

const TouristGuideRegister = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [bio, setBio] = useState('');
  const [pictureURL, setPictureURL] = useState(''); // For the image URL
  const [status, setStatus] = useState(''); // Registration status
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus('بدء التسجيل...');

    try {
      // Step 1: Create user account
      setStatus('إنشاء حساب المستخدم...');
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Step 2: Save user data to Firestore
      setStatus('حفظ بيانات المستخدم...');
      await setDoc(doc(db, 'touristGuides', user.uid), {
        name,
        bio,
        picture: pictureURL || 'https://via.placeholder.com/300', // Use placeholder if no URL is provided
        createdAt: new Date(),
      });

      setStatus('تم التسجيل بنجاح!');
      alert('تم تسجيل الدليل السياحي بنجاح!');
      setLoading(false);

      navigate('/tourist-guide');
    } catch (err) {
      console.error(err);
      setStatus('خطأ: ' + err.message);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-r from-green-400 to-blue-500 flex items-center justify-center p-6">
      <div className="bg-white p-8 rounded-lg shadow-xl w-full max-w-md">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">تسجيل كدليل سياحي</h2>
        <form onSubmit={handleRegister}>
          {/* Name Field */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-600" htmlFor="name">
              الاسم الكامل
            </label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="mt-2 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              required
            />
          </div>

          {/* Email Field */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-600" htmlFor="email">
              عنوان البريد الإلكتروني
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              required
            />
          </div>

          {/* Password Field */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-600" htmlFor="password">
              كلمة المرور
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              required
            />
          </div>

          {/* Bio Field */}
          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-600" htmlFor="bio">
              السيرة الذاتية
            </label>
            <textarea
              id="bio"
              value={bio}
              onChange={(e) => setBio(e.target.value)}
              className="mt-2 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              rows="4"
              required
            />
          </div>

          {/* Image URL Field */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-600" htmlFor="pictureURL">
              رابط صورة الملف الشخصي
            </label>
            <input
              type="url"
              id="pictureURL"
              value={pictureURL}
              onChange={(e) => setPictureURL(e.target.value)}
              className="mt-2 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              placeholder="https://example.com/profile.jpg"
            />
          </div>

          {/* Status Message */}
          {status && <p className="text-blue-500 text-sm mb-4">{status}</p>}

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full py-3 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500"
            disabled={loading}
          >
            {loading ? 'جاري التسجيل...' : 'تسجيل'}
          </button>
        </form>

        <p className="text-center text-sm text-gray-500 mt-4">
          أنت دليل سياحي بالفعل؟{' '}
          <a href="/tourist-guide-login" className="text-green-600 hover:underline">
            قم بتسجيل الدخول هنا
          </a>
        </p>
      </div>
    </div>
  );
};

export default TouristGuideRegister;
